import React, { ReactNode } from 'react';
import './TimelineComponent.scss';

interface IBookmarkProps {
  className?: string;
  children: ReactNode;
}

export const Bookmark: React.FC<IBookmarkProps> = ({ className, children, ...restProps }) => {
  return (
    <li {...restProps} className={`timeline-item ${className || ''}`}>
      {children}
    </li>
  );
};
